import React, { useState } from "react";

import { Calendar } from "react-modern-calendar-datepicker";
import Dialog from "rc-dialog";
import dayjs from "dayjs";
import moment from "moment";
import { dateTimeFormat } from '../../../constants';

const DateRangePicker = (props) => {
    const lastWeek = dayjs().subtract(1, "week");
    const today = dayjs();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedDayRange, setSelectedDayRange] = useState({
        from: props.fromDate ? {
            year: parseInt(moment(props.fromDate).format('YYYY')),
            month: parseInt(moment(props.fromDate).format('MM')),
            day: parseInt(moment(props.fromDate).format('DD')),
        } : {
            year: lastWeek.year(),
            month: lastWeek.month() + 1,
            day: lastWeek.date(),
        },
        to: props.toDate ? {
            year: parseInt(moment(props.toDate).add(-1, 'days').format('YYYY')),
            month: parseInt(moment(props.toDate).add(-1, 'days').format('MM')),
            day: parseInt(moment(props.toDate).add(-1, 'days').format('DD')),
        } : {
            year: today.year(),
            month: today.month() + 1,
            day: today.date(),
        },
    });

    const showModal = () => {
        setIsModalOpen(true);
    };

    const handleCancel = () => {
        setIsModalOpen(false);

        const dateToReturn = {
            from: {
                year: selectedDayRange.from.year,
                month: selectedDayRange.from.month - 1,
                day: selectedDayRange.from.day,
            },
            to: {
                year: selectedDayRange.to.year,
                month: selectedDayRange.to.month - 1,
                day: selectedDayRange.to.day,
            },
        }

        const fromDate = moment(dateToReturn.from).format(dateTimeFormat);
        const toDate = moment(dateToReturn.to).format(dateTimeFormat);

        props.onClose(fromDate, toDate);
    };

    const handleClearDates = () => {
        setSelectedDayRange({
            from: null,
            to: null,
        });
    };

    const selectLastWeek = (numberWeek = 1) => {
        const lastWeek = dayjs().subtract(numberWeek, "week");
        const today = dayjs();

        setSelectedDayRange({
            from: {
                year: lastWeek.year(),
                month: lastWeek.month() + 1,
                day: lastWeek.date(),
            },
            to: {
                year: today.year(),
                month: today.month() + 1,
                day: today.date(),
            },
        });
    };

    const selectLastMonth = (numberMonth = 1) => {
        const lastMonth = dayjs().subtract(numberMonth, "month");
        const today = dayjs();

        setSelectedDayRange({
            from: {
                year: lastMonth.year(),
                month: lastMonth.month() + 1,
                day: lastMonth.date(),
            },
            to: {
                year: today.year(),
                month: today.month() + 1,
                day: today.date(),
            },
        });
    };

    return (
        <>

            <>
                <div
                    className={`inline-flex items-center flex-wrap border px-4 pb-2 mr-2 border-cyan-300 rounded-full`}
                >
                    {selectedDayRange.from && (
                        <div className="truncate flex items-center space-x-2 mt-2 mr-3 last:mr-0">
                            <span>{`${selectedDayRange.from.month}/${selectedDayRange.from.day}/${selectedDayRange.from.year}`}</span>
                        </div>
                    )}

                    {selectedDayRange.to && (
                        <>
                            <div className="truncate flex items-center space-x-2 mt-2 mr-3 last:mr-0">
                                <span style={{ marginRight: '9px', marginLeft: '7px' }}>To</span>
                                <span>{`${selectedDayRange.to.month}/${selectedDayRange.to.day}/${selectedDayRange.to.year}`}</span>
                            </div>
                        </>
                    )}
                </div>
            </>

            <>
                <button
                    type="button"
                    onClick={showModal}
                    className="inline-block relative overflow-hidden text-sm truncate font-semibold bg-purple-100 py-2.5 px-5 mr-2 rounded-full"
                >
                    <svg
                        width="31"
                        height="40"
                        viewBox="0 0 31 40"
                        className="absolute left-0 top-0"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            opacity="0.7"
                            d="M0 20C0 8.9543 8.9543 0 20 0H21C4 20.5 31 40 31 40H20C8.9543 40 0 31.0457 0 20Z"
                            fill="url(#paint0_linear_694_1301)"
                        />
                        <defs>
                            <linearGradient
                                id="paint0_linear_694_1301"
                                x1="20"
                                y1="-1.88392e-06"
                                x2="33"
                                y2="44.5"
                                gradientUnits="userSpaceOnUse"
                            >
                                <stop stopColor="#D9CAEB" />
                                <stop offset="1" stopColor="#F1EAFA" />
                            </linearGradient>
                        </defs>
                    </svg>

                    <svg
                        stroke="currentColor"
                        fill="none"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="inline-block w-5 h-5 text-cyan-500 mr-2"
                        height="1em"
                        width="1em"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                        <line x1="16" y1="2" x2="16" y2="6"></line>
                        <line x1="8" y1="2" x2="8" y2="6"></line>
                        <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    <span>Customize Date</span>
                </button>
            </>


            <Dialog
                visible={isModalOpen}
                className="!max-w-xl"
                onClose={handleCancel}
                closeIcon={() => <></>}
            >
                <div className="flex">
                    <div
                        className={`relative z-0 ${selectedDayRange.to && selectedDayRange.from && "multi-selected"
                            }`}
                    >
                        <Calendar
                            value={selectedDayRange}
                            onChange={setSelectedDayRange}
                            colorPrimary="#00BBA7"
                            colorPrimaryLight="#C0EAED"
                            // className="shadow-0"
                            calendarClassName="custom-calendar"
                            renderFooter={() => {
                                return (
                                    <div className="flex text-sm justify-between items-center">
                                        <div className="flex flex-col space-y-1 text-[#33475B]">
                                            <table>
                                                <tr>
                                                    <td className="text-right">
                                                        <span className="text-cyan-400 font-[400]">
                                                            From:
                                                        </span>
                                                    </td>
                                                    <td className="!pl-2">
                                                        <span className="font-medium">
                                                            {selectedDayRange.from &&
                                                                dayjs(
                                                                    `${selectedDayRange.from.year}-${selectedDayRange.from.month}-${selectedDayRange.from.day}`
                                                                ).format("MMMM DD YYYY")}
                                                        </span>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="text-right">
                                                        <span className="text-cyan-400 font-[400]">
                                                            To:
                                                        </span>
                                                    </td>
                                                    <td className="!pl-2">
                                                        <span className="font-medium">
                                                            {selectedDayRange.to &&
                                                                dayjs(
                                                                    `${selectedDayRange.to.year}-${selectedDayRange.to.month}-${selectedDayRange.to.day}`
                                                                ).format("MMMM DD YYYY")}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </table>
                                        </div>

                                        <div className="">
                                            <button
                                                type="button"
                                                onClick={handleCancel}
                                                disabled={!selectedDayRange.from}
                                                className={`inline-block items-center ${selectedDayRange.from
                                                    ? "bg-orange-400 text-white"
                                                    : "bg-[#F2EAFA] text-[#33475B] opacity-80"
                                                    } rounded-full text-sm !px-4 !py-2 `}
                                            >
                                                <span>Done</span>
                                            </button>
                                        </div>
                                    </div>
                                );
                            }}
                        />

                        <button
                            type="button"
                            onClick={handleClearDates}
                            className="absolute z-10 right-0 top-1.5 text-sm text-cyan-500 hover:text-cyan-500"
                        >
                            Clear
                        </button>
                    </div>

                    <div className="flex-grow flex flex-col justify-center items-center space-y-3 px-4" style={{ paddingLeft: '0' }}>
                        <button
                            type="button"
                            onClick={() => selectLastWeek(1)}
                            className="text-[#425B76] bg-[#F2EAFA] rounded-full px-5 py-2 text-sm max-w-[150px] w-full"
                        >
                            Last week
                        </button>

                        <button
                            type="button"
                            onClick={() => selectLastWeek(2)}
                            className="text-[#425B76] bg-[#F2EAFA] rounded-full px-5 py-2 text-sm max-w-[150px] w-full"
                        >
                            Last two weeks
                        </button>

                        <button
                            type="button"
                            onClick={() => selectLastMonth(1)}
                            className="text-[#425B76] bg-[#F2EAFA] rounded-full px-5 py-2 text-sm max-w-[150px] w-full"
                        >
                            Last month
                        </button>

                        <button
                            type="button"
                            onClick={() => selectLastMonth(3)}
                            className="text-[#425B76] bg-[#F2EAFA] rounded-full px-5 py-2 text-sm max-w-[150px] w-full"
                        >
                            Last 3 months
                        </button>
                    </div>
                </div>
            </Dialog>
        </>
    );
};

export default DateRangePicker;
